// Mirrors app/utils/maskSecretPath.js in vlg-api. A payment-link token is a 64-hex PATH segment
// that on its own authorizes charging the client's card, and on /pay/:token it sits in the
// customer's address bar — so the browser SDK ships it too, not just the server.
const SECRET_PATH_SEGMENT = /\/[0-9a-f]{32,}(?=\/|$|\?)/gi

// The e-sign identifier is a bearer credential shaped like every other `_id` in the system, so it
// can only be masked where its position proves what it is: directly under the two routes that
// accept it as authorization. Anywhere else a UUID is an ordinary record id and must survive.
const SECRET_UUID_SEGMENT =
  /(\/(?:doc-sign|esign-doc)\/)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$|\?|#)/gi

export const maskSecretPath = (url) => (url || '')
  .replace(SECRET_PATH_SEGMENT, '/****')
  .replace(SECRET_UUID_SEGMENT, '$1****')

const BREADCRUMB_URL_KEYS = ['url', 'from', 'to']

export const scrubSecretUrls = (event) => {
  if (!event || typeof event !== 'object') return event

  if (event.request?.url) event.request.url = maskSecretPath(event.request.url)

  if (Array.isArray(event.breadcrumbs)) {
    event.breadcrumbs.forEach((breadcrumb) => {
      const data = breadcrumb?.data
      if (!data) return
      BREADCRUMB_URL_KEYS.forEach((key) => {
        if (typeof data[key] === 'string') data[key] = maskSecretPath(data[key])
      })
    })
  }

  return event
}
